import axios from 'axios';
import axiosInstance from './axios';
import * as LocalStorageService from '../utils/localStorageService';
import logger from 'utils/logger';


const deviceId = LocalStorageService.getItem('deviceId');

export const validateGuest = (data) =>
  axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/demo-guest-validate/`,
    data
  );


export const registerExtraGuest = async (body) => {
  return await axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/add-extra-guest/`,
    body
  );
};

export const userDemoRequest = async () =>
  axiosInstance.get(`/api/v1/demo-list/?order=true`);

export const userDemoAccepted = async () =>
  axiosInstance.get(`/api/v1/demo-accepted/?order=true`);

export const userDemoAcceptedStore = async (param) =>
  axiosInstance.get(`/api/v1/demo-accepted-store/${param}`);

export const userDemoPendingStore = async () =>
  axiosInstance.get(`/api/v1/demo-pending-store/?order=true`);

export const userAcceptDemo = async (data, params) =>
  axiosInstance.put(`/api/v1/demo-schedule/${params}/`, data);

export const userRejectDemo = async (data, params) =>
  axiosInstance.put(`/api/v1/demo-decline/${params}/`, data);

export const rejectDemoRequestStore = async (data, params) =>
  axiosInstance.put(`/api/v1/product-approve/${params}/`, data);

export const rejectDemoRequestAdmin = async (data, params) =>
  axiosInstance.put(`/api/v1/admin-product-review/${params}/`, data);

export const deleteReviewRequest = async (params) =>
  axiosInstance.delete(`/api/v1/product-review/${params}/`);

export const requestForReviewByHost = async (data) =>
  axiosInstance.post(`/api/v1/product-review/`, data);

export const editReviewByHostPut = async (id, data) =>
  axiosInstance.put(`/api/v1/product-review/${id}/`, data);

export const hostSeeRequest = async (params) =>
  axiosInstance.get(`/api/v1/product-review/${params}`);

export const hostProductReviewEdit = async (id) =>
  axiosInstance.get(`/api/v1/product-review/${id}/`);

export const hostSeeRequestOnce = async (params) =>
  axiosInstance.get(`/api/v1/product-review-unique/${params}`);

export const hostSeeRequestAdmin = async (params) =>
  axiosInstance.get(`/api/v1/admin-product-review/${params}`);

export const hostCancelAcceptedDemo = async (data, params) =>
  axiosInstance.put(`/api/v1/demo-cancel/${params}/`, data);

export const hostUserRescheduleDemo = async (data, params) =>
  axiosInstance.put(`/api/v1/demo-reschedule/${params}/`, data);

export const guestRescheduleDemo = async (data, params) =>
  axios.put(
    `${process.env.REACT_APP_BASE_URL}/api/v1/demo-reschedule/${params}/`,
    data
  );

export const getPBAdminHostData = async (params) =>
  axiosInstance.get(`/api/v1/purebrand-host-list/${params}`);

export const getPBAdminCompanyData = async (params) =>
  axiosInstance.get(`/api/v1/purebrand-company-list/${params}`);

export const companyFullData = async (param) =>
  axiosInstance.get(`/api/v1/purebrand-company-get/${param}/`);

export const deleteMediaOnceHost = async (param) =>
  axiosInstance.delete(`/api/v1/product-media/${param}`);

export const uploadNewEditedMedia = async (data) =>
  axiosInstance.post(`/api/v1/product-media/`, data);

export const getExistingSoftReview = async (params) =>
  axiosInstance.get(`/api/v1/soft-review-history/${params}`);

export const getDemoSatusPublic = async (demoId, uid, source, ipAddress) =>
  axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/api/v1/demo-status/${demoId}/`,
    {
      params: {
        ...(uid && { uid }),
        ...(source && { source }),
        ...(ipAddress && { ip_address: ipAddress }),
      },
    }
  );


/**
 * Makes an API call to retrieve the authorization status of a host in the demo.
 *
 * @param {number} params - The ID or unique identifier for the demo.
 * @returns {Promise<object>} - A promise that resolves to the response object containing the demo authorization status data.
 *
 * @example
 * getDemoStatusAuthenticated(123)
 *   .then(response => console.log(response.data))
 *   .catch(error => console.error(error));
 */
export const getDemoStatusAuthenticated = async (params) =>
  axiosInstance.get(`/api/v1/demo-status/${params}/`);

export const getHostOtherAccepted = async (params) =>
  axiosInstance.get(`/api/v1/demo-accepted-user-store/${params}`);

export const demoGuestPresence = async (param, data) =>
  axios.put(
    `${process.env.REACT_APP_BASE_URL}/api/v1/demo-guest-presence/${param}/`,
    data
  );

export const demoHostPresence = async (param, data) => {
  const response = await axios({
    method: 'put',
    url: `${process.env.REACT_APP_BASE_URL}/api/v1/demo-host-presence/${param}/`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + LocalStorageService.getAccessToken(),
      deviceid: deviceId,
      devicetype: 'web',
    },
    data: data,
  });
  return response;
};

/**
 * This function is used to make a api call for the authorization of a host in the demo.
 *
 * @param {object} data to be passed in the body
 * @returns {object} Response object with the data
 */

export const authorizeHostForDemo = async (data) => {
  return await axiosInstance({
    method: 'post',
    url: `${process.env.REACT_APP_BASE_URL}/api/v1/demo-authorize-host/`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + LocalStorageService.getAccessToken(),
      deviceid: deviceId,
      devicetype: 'web',
    },
    data,
  });
};

/**
 * This function is used to generate a live demo
 *
 * @param {object} data to be passed in the body
 * @returns {object} Response object with the data
 */

export const generateLiveDemo = async (data) => {
  return await axiosInstance({
    method: 'post',
    url: `${process.env.REACT_APP_BASE_URL}/api/v1/generate-live-demo/`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + LocalStorageService.getAccessToken(),
      deviceid: deviceId,
      devicetype: 'web',
    },
    data,
  });
};

export let getHostDemosByType = async (type) => {
  try {
    const response = await axiosInstance.get(
      `/api/v1/host-demos/?type=${type}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};


/**
 * This function is used to authorize a live demo
 *
 * @param {object} data to be passed in the body
 * @returns {object} Response object with the data
 */

export const authorizeLiveMeeting = async (data, user, loggedIn) => {
  const headers = {
    'Content-Type': 'application/json',
    deviceid: deviceId,
    devicetype: 'web',
  };

  if (user && loggedIn) {
    headers.Authorization = 'Bearer ' + LocalStorageService.getAccessToken();
  }

  return await axiosInstance({
    method: 'post',
    url: `${process.env.REACT_APP_BASE_URL}/api/v1/live-demo-authorize-host/`,
    headers,
    data,
  });
};


/**
 * This function is used to get all the store categories
 *
 * @param {object} data to be passed in the body
 * @returns {object} Response object with the data
 */

export const getAllStoreCategories = async (data) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  return await axiosInstance({
    method: 'get',
    url: `${process.env.REACT_APP_BASE_URL}/api/v1/all-categories-shopify/?store_identifier=${data?.store_identifier}`,
    headers,
  });
};

export const getHostProductCategories = async (data) => {
  const headers = {
    'Content-Type': 'application/json',
  };

  return await axiosInstance({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/api/v1/host-product-categories/?store_identifier=${data?.store_identifier}&host_id=${data?.host_id}`,
    headers,
  });
};

/**
 * This function is used for a guest to join a live demo
 *
 * @param {object} data to be passed in the body
 * @returns {object} Response object with the data
 */

export const guestJoiningLiveDemo = async (data) => {
  const headers = {
    'Content-Type': 'application/json',
    deviceid: deviceId,
    devicetype: 'web',
  };

  return await axiosInstance({
    method: 'put',
    url: `${process.env.REACT_APP_BASE_URL}/api/v1/live-demo-guest-join/`,
    headers,
    data,
  });
};

/**
 * This function is used to make a api call for the demo accept attempts.
 *
 * @param {object} data to be passed in the body
 * @returns {object} Response object with the data
 */

export const demoAcceptAttempt = async (data, user, loggedIn) => {
  const headers = {
    'Content-Type': 'application/json',
    deviceid: deviceId,
    devicetype: 'web'
  };

  if (user && loggedIn) {
    headers.Authorization = 'Bearer ' + LocalStorageService.getAccessToken();
  }

  return axiosInstance({
    method: 'post',
    url: `${process.env.REACT_APP_BASE_URL}/api/v1/demo-accept-attempts/`,
    headers,
    data
  });
};
export const sendGuestOtp = async (data) => {
  return await axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/demo-meeting-otp/send/`,
    data
  );
}
export const verifyGuestOtp = async (data) => {
  return await axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/demo-meeting-otp/verify/`,
    data
  );
}

/**
 * Creates a chat message in the database for a demo session.
 * The message_time will be converted from timestamp to datetime on the backend.
 *
 * @param {Object} data
 * @param {string} data.demo_id
 * @param {string} data.message_id
 * @param {string} data.message
 * @param {number} data.message_time
 * @param {string} data.user_id
 * @param {string} [data.error_code]
 * @returns {Promise<Object>}
 * @throws {Error}
 *
 * @example
 * createChatMessage({
 *   demo_id: '123e4567-e89b-12d3-a456-426614174000',
 *   message_id: 'msg-123',
 *   message: 'Hello, this is a test message',
 *   message_time: 1699123456789,
 *   user_id: 'user-456',
 *   error_code: null
 * })
 *   .then(response => console.log('Message stored:', response.data))
 *   .catch(error => console.error('Failed to store message:', error));
 */
export const createChatMessage = async data => {
  return axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/chat-messages/`,
    data
  );
};

/**
 * Sends a chat message to backend — Claude detects if it's a question,
 * refines it, and stores it in the database in a single call.
 *
 * @param {Object} data
 * @param {string} data.message  - Raw message from the guest
 * @param {string} data.demo_id  - Current demo ID
 * @param {string} data.user_id  - Participant's user ID
 * @returns {Promise<Object>}
 */
export const refineQuestion = async data => {
  return axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/chat-messages/refine-question/`,
    data
  );
};

/**
 * Gets chat messages for a specific demo session.
 *
 * @param {string} demoId - The demo identifier
 * @returns {Promise<Object>} Response containing chat messages
 * @throws {Error}
 */
export const getChatMessages = async demoId => {
  return axiosInstance.get(
    `/api/v1/chat-messages/list/`,
    { params: { demo_id: demoId } }
  );
};

/**
 * Fetches pros and cons for a specific demo
 * @param {string} demoId - The demo ID
 * @returns {Promise} API response with pros and cons data
 */
export const getDemoProsCons = async (demoId) => {
  try {
    const response = await axiosInstance.get(`/api/v1/demo-pros-cons/list/?demo_id=${demoId}`);
    return response;
  } catch (error) {
    logger.error('Error fetching demo pros and cons:', error);
    throw error;
  }
};

/**
 * Toggles whether multiple guests may join the demo session.
 * When enabled, the backend sets max_guests_allowed to a high limit; when disabled, it sets it to 1.
 *
 * @param {Object} body - Request payload.
 * @param {string} body.demo_id - UUID of the demo session.
 * @param {boolean} body.is_multiple_guests_allowed - Desired multiple-guests setting.
 * @returns {Promise<import('axios').AxiosResponse>} API response with updated guest limit data.
 * @throws {Error} When the request fails or the caller is not the demo host.
 */
export const toggleMultipleGuestsAllowed = async (body) => {
  return axiosInstance.patch('/api/v1/demo/toggle-multiple-guests/', body);
};